<template>
  <div id="lay-content">
<!--    <top-nav :shrinked="shrinked"/>-->
    <router-view></router-view>
    <v-foot/>
  </div>
</template>

<script>
  var that = null
  import VFoot from '@/components/base/v-foot'
  import topNav from '@/components/base/top-nav'
  export default {
    name: 'layout',
    components: {
      VFoot,
      // topNav
    },
    data(){
        return {
            shrinked:false
        }
    },
    mounted() {
      that = this
      window.addEventListener("scroll", this.scrollEvent)
    },
      methods:{
          /**
           *  监听滚动事件
           */
          scrollEvent(){
              this.shrinked = window.scrollY >= 10?true:false
          }
      }
  }
</script>
<style>
  #lay-content{

  }
</style>
